import React, { useEffect, useState, useRef } from "react";
import "./BackgroundSetting.css"
import { useConfig } from './ConfigContext';

const BackgroundSetting = () => {
    const [webglUrl, setWebglUrl] = useState("");
    const [backgroundColor, setBackgroundColor] = useState(() => {
        const savedColor = sessionStorage.getItem("backgroundColor");
        return savedColor ? savedColor : "#FFFFFF";
    });
    const isInitialMount = useRef(true);
    const config = useConfig();

    useEffect(() => {
        if (config) {
            setWebglUrl(config["webgl_url"]);
        }
    }, [config]);


    useEffect(() => {
        if (webglUrl && window.webglIframe) {
            if (!isInitialMount.current) {
                window.webglIframe.contentWindow.postMessage({ type: 'webgl_set_background_color', value: backgroundColor }, webglUrl);
            } else {
                isInitialMount.current = false;
            }
        }
    }, [webglUrl, backgroundColor]);

    const handleColorChange = (e) => {
        const newColor = e.target.value;
        setBackgroundColor(newColor);
        sessionStorage.setItem("backgroundColor", newColor);
    };

    return (
        <div className="background-container">
            <h4 style={{ marginBottom: "15px" }}>Background Settings</h4>
            <div>
                <label>Background Color</label>
                <input
                    type="color"
                    value={backgroundColor}
                    onChange={handleColorChange}
                    style={{ marginBottom: "15px" }}
                />
            </div>
        </div>
    );
};

export default BackgroundSetting;
